import { useNavigate } from '@tanstack/react-router';
import { memo, useCallback, useMemo } from 'react';

import { Flex, Heading, Save, Text } from '@/components/core';
import { CradlLogo } from '@/components/logos';
import { OrganizationCard } from '@/features/organizations';
import { useNewOrganizations } from '@/hooks';
import { toProfileId, useGetProfile, useListOrganizations } from '@/hooks/api';

export type OrganizationsProps = object;

// eslint-disable-next-line no-empty-pattern
const IOrganizations = ({}: OrganizationsProps) => {
  const { data: profile } = useGetProfile(toProfileId('me'));
  const navigate = useNavigate();

  const onLoginToOrganization = useCallback(
    (code: string) => {
      navigate({ to: '/login', search: { orgCode: code } });
    },
    [navigate]
  );

  const { data, isPending } = useNewOrganizations(useListOrganizations());
  const organizations = useMemo(() => data?.data ?? [], [data]);

  return (
    <div className="flex h-screen flex-col items-center justify-center gap-8 bg-gradient-to-b from-white to-slate-200">
      <Flex className="items-center gap-2">
        <CradlLogo size="xl" />
        <Heading>Cradl AI</Heading>
      </Flex>

      <Flex col className="w-[35rem] gap-4 rounded-lg bg-white p-6 shadow">
        {isPending ? (
          <Save message="Loading organizations" />
        ) : (
          <>
            <Heading>Choose workspace to login to</Heading>
            <Text>
              Your email <span className="font-semibold text-gray-500">{profile?.email}</span> is associated with
              multiple Cradl workspaces.
            </Text>

            {organizations.map((o) => (
              <OrganizationCard
                onPress={() => onLoginToOrganization(o.code)}
                key={o.organizationId}
                organizationId={o.organizationId}
              />
            ))}
          </>
        )}
      </Flex>
    </div>
  );
};

export const Organizations = memo(IOrganizations) as typeof IOrganizations;
